import type { ReactNode } from "react";
import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";

export function Faq({ heading, items, theme = "paper", id }: { heading?: string; items: { question: string; answer: ReactNode }[]; theme?: Theme; id?: string }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} id={id}>
      <SectionHeader heading={heading} theme={theme} />
      <div className={`divide-y ${t.border} max-w-3xl`}>
        {items.map((it) => (
          <details key={it.question} className="group py-5">
            <summary className={`${t.heading} flex cursor-pointer list-none items-center justify-between gap-4 font-display text-lg font-semibold`}>
              {it.question}
              <span aria-hidden="true" className="text-signal transition-transform group-open:rotate-45">+</span>
            </summary>
            <div className={`${t.prose} ${t.body} mt-3`}>{it.answer}</div>
          </details>
        ))}
      </div>
    </ContainedSection>
  );
}
